import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_LovsDetail = _resolveComponent("LovsDetail")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.driversManagement.useModes.selectLov'),
    breakpoints: _ctx.useModeDescriptor.dialog.breakpoints,
    style: _ctx.useModeDescriptor.dialog.style,
    visible: _ctx.dialogVisible,
    modal: true,
    closable: false,
    class: "p-fluid kn-dialog--toolbar--primary"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.driversManagement.useModes.selectLov')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeLovDialog,
        class: "kn-button kn-button--secondary"
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('common.apply'),
        onClick: _ctx.applyLov,
        class: "kn-button kn-button--primary"
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      (!_ctx.detailVisiable)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            filters: _ctx.filters,
            "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
            filterDisplay: "menu",
            globalFilterFields: _ctx.useModeDescriptor.globalFilterFields,
            selection: _ctx.selectedLov,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedLov = $event)),
            value: _ctx.lovs,
            class: "p-datatable-sm kn-table",
            dataKey: "id",
            responsiveLayout: "stack",
            selectionMode: "single"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("span", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    type: "text",
                    modelValue: _ctx.filters.global.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.global.value = $event)),
                    placeholder: _ctx.$t('common.search'),
                    badge: "0",
                    "data-test": "search-input"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            loading: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.useModeDescriptor.columnsLov, (col) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  field: col.field,
                  header: _ctx.$t(col.header),
                  key: col.field,
                  class: "kn-truncated",
                  sortable: true
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("span", null, _toDisplayString(slotProps.data[slotProps.column.props.field]), 1)
                  ]),
                  _: 2
                }, 1032, ["field", "header"]))
              }), 128)),
              _createVNode(_component_Column, {
                headerStyle: "useModeDescriptor.table.iconColumn.style",
                style: _ctx.useModeDescriptor.table.iconColumn.style
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-info-circle",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.lovDetail(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["filters", "globalFilterFields", "selection", "value"]))
        : (_openBlock(), _createBlock(_component_LovsDetail, {
            key: 1,
            lov: _ctx.lovDetails,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailVisiable = false))
          }, null, 8, ["lov"]))
    ]),
    _: 1
  }, 8, ["header", "breakpoints", "style", "visible"]))
}